export default __webpack_public_path__ + "static/media/hp-institutions-img.44eda819.svg";